













































































































import { Vue, Component } from "vue-property-decorator";
import Api from "@/Api";

@Component
export default class Aufgaben extends Vue {
  code = "";
  data = {};
  schueler = "";
  lehrer = localStorage.getItem("role") == "lehrer";
  aufgabentext = "";
  aufgabenDatum = "";
  popupNeueAufgabe = false;
  editorButtons = [
    ["bold", "italic", "underline", "strikeThrough"],
    ["orderedList", "unorderedList"],
    ["alignLeft", "alignCenter", "alignRight", "alignJustify"],
  ];
  // editorButtons = [];
  // computed() {
  //   appVersion : "1.0.9"
  //   // other computed values here
  // }

  filterFach(fach, aufgaben) {
    const filter: any[] = [];
    aufgaben.forEach((a: any) => {
      if (fach.fach === a.fach.title) filter.push(a);
    });
    return filter;
  }

  get appversion() {
    return process.env.PACKAGE_VERSION || "1.0.0";
  }

  created() {
    (this.$f7 as any).on("login", () => {
      this.lehrer = localStorage.getItem("role") == "lehrer";
      this.laden();
    });
  }

  mounted() {
    this.laden();
  }

  link(a) {
    let url = "/aufgaben/" + a.id;
    if (localStorage.getItem("role") == "lehrer") url += "/schueler";
    (this.$f7router as any).navigate(url, {
      context: {
        aufgabe: a,
      },
    });
  }

  laden(event?: any) {
    let url = "/aufgaben";
    if (this.lehrer && localStorage.getItem("klasse"))
      url += "?klasse=" + localStorage.getItem("klasse");
    return Api.get(url)
      .then((r: any) => {
        this.data = r.data;
        this.schueler = localStorage.getItem("username") || "";
        if (event) event.detail();
      })
      .catch(() => {
        if (event) event.detail();
      });
  }

  logout() {
    (this.$f7 as any).emit("logout");
  }

  speichern() {
    Api.post("/aufgaben", {
      text: this.aufgabentext,
      datum: this.aufgabenDatum,
      klasse: localStorage.getItem("klasse"),
    }).then((r) => {
      this.aufgabentext = "";
      this.popupNeueAufgabe = false;
      this.laden();
    });
  }

  onDelete(aufgabe) {
    Api.delete("/aufgaben/" + aufgabe.id)
      .then((r) => {
        this.laden();
      })
      .finally(() => {
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
  }

  klassenWahl(k) {
    if (!this.lehrer) return false;
    localStorage.setItem("klasse", k.id);
    this.laden();
  }
}
